import axios from 'axios';

export const API_URL = window._env_.API_URL;

//export const API_URL = 'http://localhost:16371';

export const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const AUTH_CONFIG = {
  loginUrl: window._env_.CAS_LOGIN_URL,
  logoutUrl: window._env_.CAS_LOGIN_URL + `/logout`,
  serviceTicketUrl: `${window._env_.CAS_LOGIN_URL}/p3/serviceValidate`,
  autoLogon: process.env.REACT_APP_AUTO_LOGON,
  uriPublica: window._env_.FRONT_URL,
  linkCadastroCliente: window._env_.LINK_CADASTRO_CLIENTE
};
export function SERVICE_TICKET({ service, ticket }) {
  return {
    url: `${AUTH_CONFIG.serviceTicketUrl}?service=${service}&ticket=${ticket}&format=json`,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  };
}


